import React from 'react'
import Layout from './Layout'
import styles from './_layout.css'

export default function UACFLayout (props) {
  return (
    <Layout
      uacf={true}
      className={styles.auth}
      showAuth={false}
      showShortcuts={false}
      showMobileNav={false}
      showFooter={false}
      navContainer={false}
      middleContainer={false}
      {...props}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/UACFLayout.jsx